import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { EmptyState, PageHeader } from "@/components/shared/Common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime, fmtRelative } from "@/lib/format";

export default function Sessions() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/sessions").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const revoke = async (id) => {
    try { await api.post(`/admin/sessions/${id}/revoke`); toast.success("Sesión revocada"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="sessions-page">
      <PageHeader eyebrow="Administración" title="Seguridad y Sesiones" subtitle="Sesiones activas en el sistema. Revocar una sesión cierra el acceso de inmediato en ese dispositivo." />
      <div className="syc-card overflow-hidden">
        {items.length === 0 ? <EmptyState title="Sin sesiones activas" /> : items.map((s) => (
          <div key={s.id} data-testid={`session-row-${s.id}`} className="flex flex-col sm:flex-row sm:items-center gap-3 px-5 py-4 border-b border-[#f0f2ee] last:border-0">
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm">{s.user_name} <span className="font-normal text-[#5b6656]">· {s.user_email}</span>
                {s.is_current && <span className="ml-2 rounded-full bg-[#e9f7e1] px-2 py-0.5 text-[10px] font-bold text-[#1c6e00]">ESTA SESIÓN</span>}</div>
              <div className="text-xs text-[#5b6656] truncate">{s.ip} · {s.user_agent}</div>
              <div className="text-xs text-[#8a9584]">Inicio {fmtDateTime(s.created_at)} · Actividad {fmtRelative(s.last_seen)} · Expira {fmtDateTime(s.expires_at)}</div>
            </div>
            {can("admin.sesiones.revocar") && !s.is_current && (
              <Button data-testid={`revoke-session-btn-${s.id}`} size="sm" variant="outline" className="rounded-full text-[#b42318] border-[#f5c2c0]" onClick={() => revoke(s.id)}>Revocar</Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
